import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import DialogModal from './components/DialogModal';
import DialogHeader from './components/DialogHeader';
import DialogBody from './components/DialogBody';
import DialogFooter from './components/DialogFooter';

class Dialog extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      isMaskClosable = false,
      isOverFlowVisible,
      title,
      size,
      children,
      onClose,
    } = this.props;
    const bodyProps = omit(
      this.props,
      'isMaskClosable',
      'title',
      'size',
      'children',
      'onClose'
    );
    const footerProps = omit(
      this.props,
      'isMaskClosable',
      'title',
      'size',
      'children'
    );

    return (
      <DialogModal
        isMaskClosable={isMaskClosable}
        isOverFlowVisible={isOverFlowVisible}
        size={size}
        onClose={onClose}
      >
        <DialogHeader title={title} onClose={onClose} />
        <DialogBody {...bodyProps}>{children}</DialogBody>
        <DialogFooter {...footerProps} />
      </DialogModal>
    );
  }
}

Dialog.propTypes = Object.assign({}, DialogFooter.propTypes, {
  isMaskClosable: PropTypes.bool,
  isOverFlowVisible: PropTypes.bool,
  title: PropTypes.node,
  size: PropTypes.oneOf(['large']),
  children: PropTypes.node,
  onClose: PropTypes.func,
});

export default Dialog;
/**
 * Dialog 處理常見情境，如果遇到需要客製的情況 (header, body or footer)
 * 避免此元件複雜化，因此另外各別 export 讓頁面使用
 */
export { DialogModal, DialogHeader, DialogBody, DialogFooter };



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/componentsv3/Dialog/index.js
 **/